"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var FeatureFlag_1 = __importDefault(require("@CommonFrontendBackend/FeatureFlag"));
var MountReactComponent_1 = __importDefault(require("MountReactComponent/MountReactComponent"));
var AccepterList_1 = require("./AccepterList/AccepterList");
var extractNames = require("@CommonFrontendBackend/Utils/ExtractNames");
var isUsingTCDC = require("@CommonFrontendBackend/FeatureFlag").isUsingTCDC;
var AcceptButton = (function () {
    function AcceptButton(createUi, make, userIconFactory, label, click, accepters, settings, isDisabled, appEvents, usingFeature, acceptTelemetry, buildEditMenu, isInNavigation, $timeout, withAgreementBlock, isPrintMode) {
        var _this = this;
        var hideMultiAccepters = make.has("hideMultiAccepters") ? make.get("hideMultiAccepters") : false;
        var rebuildIcons = false;
        var usingTCDC = isUsingTCDC(usingFeature);
        var useNewSignaturePanel = usingFeature(FeatureFlag_1.default.SignatureInitialsWidgets);
        var icons = [];
        var createIcons = function (finalisedAccepters) {
            if (accepters.number > 1) {
                for (var i = 0; i < accepters.number; i++) {
                    if (icons[i] != null && !rebuildIcons) {
                        continue;
                    }
                    if (i < finalisedAccepters.length) {
                        var names = extractNames(finalisedAccepters[i].name);
                        var userIcon = userIconFactory.createReactIcon(names);
                        icons.push(userIcon);
                    }
                    else {
                        var userIcon = userIconFactory.createReactIcon();
                        icons.push(userIcon);
                    }
                }
                if (icons.length > accepters.number) {
                    icons = icons.splice(accepters.number, icons.length - accepters.number);
                }
            }
            rebuildIcons = false;
            return icons;
        };
        var editMenu = buildEditMenu();
        var buildUi = function () {
            var _a;
            var finalisedAccepters = (_a = accepters.finalisedAccepters) !== null && _a !== void 0 ? _a : [];
            _this.ui = createUi(require("./AcceptButton.html"), {
                label: label,
                editorIsActive: false,
                usingTCDC: usingTCDC,
                click: function () {
                    if (isInNavigation) {
                        acceptTelemetry.throttledTrack("Accept Button Clicked", { accept_button_clicked_source: "navigation" });
                        var acceptButton_1 = $(".accept-module .accept-button-v2__button");
                        $timeout(function () { return acceptButton_1.trigger("click"); });
                    }
                    else if (click) {
                        click(accepters, settings);
                    }
                    if (!isInNavigation) {
                        acceptTelemetry.throttledTrack("Accept Button Clicked", { accept_button_clicked_source: "block" });
                    }
                },
                isDisabled: isDisabled,
                icons: function () { return createIcons(finalisedAccepters); },
                numAccepters: function () {
                    return accepters.number;
                },
                lastAccepted: null,
                hideMultiAccepters: hideMultiAccepters,
                showAccepterList: isPrintMode || !withAgreementBlock,
                accepterList: (0, AccepterList_1.mountAccepterList)((0, MountReactComponent_1.default)(createUi), {
                    accepters: finalisedAccepters,
                    useNewSignaturePanel: useNewSignaturePanel,
                }),
                editMenu: editMenu,
            });
        };
        buildUi();
        appEvents.on("accepted", function () {
            rebuildIcons = true;
            buildUi();
        });
    }
    return AcceptButton;
}());
exports.default = AcceptButton;
